<script lang="ts" setup>
import { RenderPageHeaderActions, usePaneStore } from '#layers/ui/public';
import WorkspaceChromeHeaderPanelToggles from './WorkspaceChromeHeaderPanelToggles.vue';
import WorkspaceChromeSidebarToggle from './WorkspaceChromeSidebarToggle.vue';

const paneStore = usePaneStore();
</script>

<template>
	<header
		class="
			@container flex w-full items-center justify-between px-page ps-2.5 transition-[padding]
			block-(--primary-header-height)
		"
		:class="{
			'ps-3': paneStore.sidebarSplitPanelCollapsed,
			'relative before:absolute before:inset-s-0 before:border-s before:border-accented before:block-5': !paneStore.sidebarSplitPanelCollapsed,
		}"
	>
		<div class="flex min-w-0 flex-1 items-center">
			<WorkspaceChromeSidebarToggle v-if="paneStore.sidebarSplitPanelCollapsed" />

			<slot />

			<div class="ms-auto flex shrink-0 items-center gap-2">
				<RenderPageHeaderActions />
			</div>
		</div>

		<div class="flex shrink-0 items-center gap-x-1">
			<WorkspaceChromeHeaderPanelToggles />
			<OnboardingPopupToggle />
		</div>
	</header>
</template>
